export const WORDS = [
    "aussie",
    "kakadu",
    "wombat",
    "desert",
    "bogans",
    "bonzer",
    "broome",
    "cairns",
    "camels",
    "cheers",
    "chooks",
    "coffee",
    "crikey",
    "cobber",
    "dinkum",
    "darwin",
    "dundee",
    "floods",
    "farmer",
    "frothy",
    "gorges",
    "galahs",
    "gravel",
    "goanna",
    "hiking",
    "hobart",
    "holden",
    "island",
    "jarrah",
    "lizard",
    "maccas",
    "mining",
    "mozzie",
    "murray",
    "pokies",
    "python",
    "qantas",
    "quokka",
    "remote",
    "sanger",
    "sheila",
    "snagga",
    "stubby",
    "surfer",
    "sydney",
    "tassie",
    "thongs",
    "tucker",
    "undies",
    "whales",
    "plugga",
    "bugger",
    "sarnie",
    "cossie",
    "banana",
    "stings",
    "coldie",
    "cactus",
    "ripper",
    "drongo",
    "mallee",
    "galoot",
    "digger",
    "strine",
    "struth",
    "furphy",
    "fraser",
    "numbat",
    "rivers",
    "plains",
    "tinnie",
    "mutton",
    "magpie",
    "snakes",
    "spider",
    "ciggie",
    "middie",
    "mullet",
    "bourke",
    "blokey",
    "blimey",
    "straya",
    "brekky",
    "brolly",
    "wedgie",
    "bickie",
    "fellas",
    "gander",
    "howzat",
    "ticker",
    "ansett",
    "cattle",
    "prawns",
    "brumby",
    "blokes",
    "stoked",
    "ringer",
    "anzacs",
    "blotto",
    "bonner",
    "possum",
    "sharks",
    "skippy",
    "taipan",
    "thorpe",
    "timtam",
    "gumnut",
    "parrot",
    "wattle",
    "tanked",
    "sickie",
    "tradie",
    "choccy",
    "grouse",
    "budgie",
    "clucky",
    "rellie",
    "banger",
    "veggie",
    "pommie",
    "tanned",
    "ockers",
    "reckon",
    "cockie",
    "drover",
    "parmie",
    "bestie",
    "spewed",
    "stumps",
    "summer",
    "chikos",
    "tasman",
    "eskies",
    "bunyip",
    "gidday",
    "cuppas",
    "shandy",
    "sinbin",
    "nipper",
    "sporty",
    "postie",
    "preggo",
    "airlie",
    "maggie",
    "codger",
    "yobbos",
    "damper",
    "akubra",
    "dingos",
    "jaffas",
    "oldies",
    "warnie",
    "wobbly",
    "yabbie",
    "chippy",
    "blowie",
    "garbos",
    "prangs",
    "ratbag",
    "sambos",
    "servos",
    "sparky",
    "shonky",
    "squizz",
    "whinge",
    "monaro",
    "eshays",
    "grotty"
  ]
export const sixWords = async () => {
    let words: any = []
    await WORDS.map((item) => {
        if(item.length === 6){
          words.push(item)
        }
      })
      console.table(words)
}